import React, { useState, FormEvent } from 'react';
import { X, Send, Check } from 'lucide-react';
import { Permission } from '../../types/auth';
import { useAuth } from '../../context/AuthContext';

interface Props {
  onClose: () => void;
}

const ROLES: { value: Permission; label: string; desc: string }[] = [
  { value: 'viewer', label: 'Visualizador', desc: 'Só leitura, sem edições'                  },
  { value: 'editor', label: 'Editor',        desc: 'Edita membros, processos e OKRs'          },
  { value: 'admin',  label: 'Admin',         desc: 'Tudo acima + convidar e gerenciar acesso' },
];

export default function InviteModal({ onClose }: Props) {
  const { sendInvite } = useAuth();
  const [email,   setEmail]   = useState('');
  const [role,    setRole]    = useState<Permission>('viewer');
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');
  const [success, setSuccess] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await sendInvite(email, role);
      setSuccess(true);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">Convidar pessoa</div>
          <button className="modal-close" onClick={onClose}><X size={16} /></button>
        </div>

        {success ? (
          <div className="modal-body">
            <div className="invite-success">
              <div className="invite-success-icon"><Check size={18} /></div>
              <p>Convite enviado para <strong>{email}</strong></p>
              <button className="auth-submit" style={{ width: '100%' }} onClick={onClose}>
                Fechar
              </button>
            </div>
          </div>
        ) : (
          <form className="modal-body" onSubmit={handleSubmit}>
            <div className="auth-field">
              <label className="auth-label">Email</label>
              <input
                className="auth-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="email@pedbot.com.br"
                required
                autoFocus
              />
            </div>

            <div className="auth-field">
              <label className="auth-label">Perfil de acesso</label>
              <div className="role-options">
                {ROLES.map(r => (
                  <label
                    key={r.value}
                    className={`role-option${role === r.value ? ' selected' : ''}`}
                  >
                    <input
                      type="radio"
                      name="role"
                      value={r.value}
                      checked={role === r.value}
                      onChange={() => setRole(r.value)}
                    />
                    <div className="role-option-info">
                      <div className="role-option-name">{r.label}</div>
                      <div className="role-option-desc">{r.desc}</div>
                    </div>
                  </label>
                ))}
              </div>
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button className="auth-submit" type="submit" disabled={loading}>
              {loading
                ? 'Enviando…'
                : <><Send size={15} /> Enviar convite</>
              }
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
